import { render, staticRenderFns } from "./yanbaofuwu.vue?vue&type=template&id=3a7671a1&scoped=true&"
import script from "./yanbaofuwu.vue?vue&type=script&lang=js&"
export * from "./yanbaofuwu.vue?vue&type=script&lang=js&"
import style0 from "./yanbaofuwu.vue?vue&type=style&index=0&id=3a7671a1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a7671a1",
  null
  
)

export default component.exports